import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const VerificationModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const checkVerification = () => {
    const isVerified = localStorage.getItem('verified');
    setIsOpen(isVerified === 'false' || isVerified === null);
  };

  useEffect(() => {
    checkVerification();

    window.addEventListener('storage', checkVerification);

    return () => {
      window.removeEventListener('storage', checkVerification);
    };
  }, []);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Modal 
      isOpen={isOpen} 
      toggle={toggle} 
      centered 
      backdrop="static" // Evita cierre al hacer clic fuera
      keyboard={false}  // Evita cierre con tecla Esc
      contentClassName="border-0 shadow-lg"
      style={{ maxWidth: '60%', width: '60%' }}
    >
      <ModalHeader toggle={toggle} className="border-0 pb-0" />
      
      <ModalBody className="text-center pb-5 px-4">
        <div className="mb-4">
          <img 
            src="/favicon.ico" 
            alt="Logo" 
            style={{ width: '64px', height: '64px', objectFit: 'contain' }}
            className="mx-auto d-block"
          />
        </div>

        <h2 className="display-6 fw-bold text-dark mb-4" style={{ fontSize: '1.75rem' }}>
          Publicaciones restringidas
        </h2>
        
        <div className="mb-4">
          <p className="text-secondary fs-6 lh-base">
            Estamos verificando tu perfil para garantizar la seguridad de la información en la plataforma. 
            Este proceso suele tardar solo unos minutos.
          </p>
          <p className="text-secondary fs-6 lh-base">
            Una vez finalizada la verificación, recibirás un correo electrónico de confirmación.
          </p>
        </div>

        <hr className="w-25 mx-auto mb-4 opacity-10" />

        <div className="bg-light p-4 rounded-3">
          <p className="small fw-bold text-uppercase text-muted mb-2">
            Soporte Técnico
          </p>
          <p className="mb-3 text-muted small">
            Si consideras que se trata de un error o necesitas asistencia, puedes contactarnos a través de:
          </p>
          <a 
            href="mailto:jose.cruz@avanzaempleo.com.co" 
            className="btn btn-dark btn-lg px-4 fs-6 fw-semibold w-100"
          >
            jose.cruz@avanzaempleo.com.co
          </a>
        </div>

        <div className="mt-4">
          <code className="text-uppercase small text-muted opacity-50">
            Ref. ID: 002
          </code>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default VerificationModal;